export class ItemModel {
  imgURL: any;
  loanItemsPk: number;
  pk: number;
  loanItemPk: number;
  itemImageUrl: any;
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/common/models/item.model.ts